import { createContext, useContext } from "react";

export const EnquiryCtx = createContext(() => {});
export const useEnquiry = () => useContext(EnquiryCtx);
